module.exports = __webpack_public_path__ + "img/mo.41dd949e.svg";